<template>
  <div>
    <el-menu mode="horizontal" @select="handleSelect" style="background-color: #44135a" text-color="white">
      <el-menu-item class="image" index="0"><img class="img" src="../assets/PQC+Logo.png" alt="Paul Quinn College"></el-menu-item>
      <el-menu-item class="el-menu-item" index="1">Home</el-menu-item>
      <el-menu-item class="el-menu-item" index="3">Impact</el-menu-item>
      <el-menu-item class="el-menu-item" index="4">Spotlight</el-menu-item>
      <el-menu-item class="el-menu-item" index="5">Investment in Yourself Calculator</el-menu-item>
      <el-menu-item class="el-menu-item" index="6">Discussion</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  methods: {
    handleSelect(index) {
      if (index == 1) {
        this.$router.push("/");
      } else if (index == 3) {
        this.$router.push("Impact");
      } else if (index == 4) {
        this.$router.push("Spotlight");
      } else if (index == 5) {
        this.$router.push("TuitionCalculator");
      } else if (index == 6) {
        this.$router.push("QA");
      }
    },
  },
};
</script>

<style scoped>
.img {
    height: 45px;
}
.image:hover {
    background-color: #44135a !important;
}
.el-menu-item.is-active{
    background-color: white !important;
    border-bottom-color: #44135a;
    color: #44135a;
}
.el-menu-item:hover{
    background-color: white !important;
    border-bottom-color: #44135a;
    color: #44135a !important;
}
.el-menu.el-menu--horizontal {
    border-bottom: none !important;
}
</style>
